import { render, staticRenderFns } from "./BtnAceitarCondicoesContratuais.vue?vue&type=template&id=2fa8b6d4"
import script from "./BtnAceitarCondicoesContratuais.vue?vue&type=script&lang=js"
export * from "./BtnAceitarCondicoesContratuais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports